import React, { useEffect, useState } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import DashboardHeader from "../../Pages/DashboardHeader/DboardHeader";
import Sidebarcomp from "../../Pages/Sidebar/Sidebar";
import "./admin.css";
import { CommunityOwner } from "../../Utils/Constant";
import { useDispatch, useSelector } from "react-redux";
import { fetchProfileData } from "../../Services/Profile/ProfileApi";
import TrialAlertBanner from "../../Pages/TrialAlertBanner/TrialAlertBanner";

function Admin() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showAlertBanner, setShowAlertBanner] = useState(false);
  const userId = localStorage.getItem("user_id");
  const headerMessage = useSelector((state) => state.ui.headerMessage);
  const { data: profileData } = useSelector(
    (state) => state.fetchProfileData.data
  );
  const [daysLeft, setDaysLeft] = useState(0);

  useEffect(() => {
    if (profileData?.is_trial_activated && profileData?.trial_ends_at) {
      const trialEndDate = new Date(profileData.trial_ends_at);
      const today = new Date();
      const differenceInTime = trialEndDate - today;
      const remainingDays = Math.ceil(differenceInTime / (1000 * 60 * 60 * 24));

      if (remainingDays > 0 && remainingDays <= 10) {
        // Trial is about to expire in 10 days or less
        setShowAlertBanner(true);
        setDaysLeft(remainingDays);
      } else if (remainingDays <= 0) {
        // Trial has ended
        setShowAlertBanner(true);
        setDaysLeft(0); // Indicate that the trial has ended
      } else {
        setShowAlertBanner(false); // Trial is not expiring soon or already expired
      }
    } else {
      setShowAlertBanner(false); // No trial activated
    }
  }, [profileData]);

  useEffect(() => {
    // Retrieve the access token and user role from localStorage
    const accessToken = localStorage.getItem("access_token");
    const userType = localStorage.getItem("user_type");

    // Check if the user is authenticated and is a super-admin
    if (!accessToken || !userType || userType !== CommunityOwner) {
      // If not authenticated or not a super-admin, redirect to login page
      navigate("/login");
    }
  }, [navigate]);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  useEffect(() => {
    dispatch(fetchProfileData(userId));
    // if (headerMessage === "Community Management")
    //   navigate("/admin/Admin-community");
    // else
    if (headerMessage === "Subscription Plans")
      navigate("/admin/subscriptions");
    else if (headerMessage === "Active Subscriptions")
      navigate("/admin/active-subscriptions");
    else if (headerMessage === "History") navigate("/admin/history");
    else if (headerMessage === "Profile") navigate("/admin/admin-profile");
    else if (headerMessage === "Dashboard") navigate("/admin/dashboard");
    // else navigate("/login");
  }, [dispatch, headerMessage, userId]);

  return (
    <div className="layout d-flex">
      <Sidebarcomp isCollapsed={isCollapsed} onToggle={toggleSidebar} />
      <div
        className={`main-components d-flex flex-column ${
          isCollapsed ? "full-width" : ""
        }`}
      >
        <DashboardHeader />

        <TrialAlertBanner
          showAlertBanner={showAlertBanner}
          setShowAlertBanner={setShowAlertBanner}
          daysLeft={daysLeft}
        />

        <Outlet />
      </div>
    </div>
  );
}

export default Admin;
